import * as React from "react";
import { TreeNode, TreeView } from "baseui/tree-view";
import { mergeOverrides } from "baseui/helpers/overrides";

import { Select, TSelectProps } from "../Select";
import { maybe } from "../utils/functional";
import { toggleKey } from "../utils/primitives";
import { filterKey } from "../utils/filter";
import { transformTree, flattenLeaves, hasChildren } from "../utils/tree";
import { useFuseSearch } from "./hooks";

const { useState } = React;

type TTreeSelect = {
  options: unknown;
  filterFunc?: (object: unknown, filter: unknown, key?: string) => void;
  startFilter?: string;
  startExpanded?: unknown;
} & TSelectProps;

// TODO: Need to refactor this component.
// TODO: https://app.clickup.com/t/2703166/DEV-3188
export const TreeSelect: React.FC<TTreeSelect> = ({
  options,
  filterFunc = filterKey,
  startFilter = "",
  startExpanded = {},
  overrides: treeSelectOverrides = {},
  ...props
}) => {
  const [expanded, setExpanded] = useState(startExpanded);
  const [filter, setFilter] = useState(startFilter);
  const search = useFuseSearch(options);
  function handleInputChange(event) {
    setFilter(event.target.value);
  }
  const filteredOptions = filter ? search(filter) : options;
  const transformFunc = filter
    ? (node) => ({ ...node, isExpanded: true })
    : (node) => ({ ...node, isExpanded: expanded[node.id] });
  const expandedOptions = transformTree(filteredOptions, transformFunc);
  const leaves = flattenLeaves(expandedOptions);
  function onToggle(item) {
    setExpanded(toggleKey(expanded, item.id));
  }
  const overrides = mergeOverrides(
    {
      StatefulMenu: {
        component: TreeDropdown,
        props: {
          onToggle,
          expandedOptions,
        },
      },
    },
    treeSelectOverrides
  );
  return (
    <Select
      options={leaves}
      onInputChange={handleInputChange}
      filterOptions={null}
      noResultsMsg={filter.length > 2 ? "No results" : "3 characters required ..."}
      overrides={overrides}
      clearable={false} // Disabling clear feature as it is not resetting previous search
      {...props}
    />
  );
};

type TTreeDropdown = {
  expandedOptions: TreeNode<any>[];
  onToggle?: (...args: unknown[]) => void;
  onItemSelect?: (...args: unknown[]) => void;
};
const TreeDropdown: React.FC<TTreeDropdown> = ({
  expandedOptions,
  onToggle,
  onItemSelect,
}) => {
  return (
    <TreeView
      data={expandedOptions}
      onToggle={(item) => {
        if (hasChildren(item)) {
          maybe(onToggle)(item);
        } else {
          maybe(onItemSelect)({ item });
        }
      }}
      overrides={{
        Root: {
          style: {
            maxHeight: "300px",
          },
        },
        TreeItemContent: {
          style: {
            cursor: "pointer",
          },
        },
        TreeLabel: {
          style: ({ $theme }) => ({
            color: $theme.colors.contentPrimary,
            cursor: "pointer",
          }),
        },
        IconContainer: {
          style: {
            pointerEvents: "none",
          },
        },
      }}
    />
  );
};
